export default class ErpNotepadEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_notepad_id") ? (elem.querySelector("#erp_notepad_id") as HTMLInputElement).value : null,
            note: (elem.querySelector("#erp_notepad_note") as HTMLInputElement).value,
        }
    }
}